
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/joy-ui/react-stack",
      function () {
        return require("private-next-pages/joy-ui/react-stack.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/joy-ui/react-stack"])
      });
    }
  